var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"askingBottom"},[_c('img',{attrs:{"src":require("../assets/image/a.png"),"alt":""}}),_c('div',{staticClass:"setAsking"})])
}]

export { render, staticRenderFns }